export default "__VITE_ASSET__WuKhD_df__"